import * as yup from 'yup';
import { fieldValidationMessages } from 'app/constants';

export const InvalidTokenMessage =
  'Verification code is incorrect. Please try again';

export const ConfirmFormSchema = yup.object({
  token: yup.string().required(fieldValidationMessages.REQUIRED).length(6),
});

export type Form = yup.InferType<typeof ConfirmFormSchema>;
